<script lang="ts" setup>
    import AuthLoginForm from '../AuthLoginForm.vue';
    import { RoleAccessStatus } from '~/utils/roleAccess';

    const props = defineProps<{
        authStatus?: RoleAccessStatus;
    }>();

    const isForbidden = computed(() => props.authStatus === RoleAccessStatus.Forbidden);
</script>

<template>
    <div
        class="adventcalendar-modal-wrapper login-modal"
        role="dialog"
        aria-modal="true"
    >
        <div class="adventcalendar-modal-content">
            <template v-if="isForbidden">
                <AuthLoginForm />
            </template>

            <template v-else>
                <div class="adventcalendar-modal-content-text">
                    <AccountLoginForm />
                </div>
            </template>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/pta-family/adventcalendar/adventcalendar-modal.scss';
</style>
